export default function About() {
  const stats = [
    { number: '500+', label: 'Contractors Served' },
    { number: '$50M+', label: 'Revenue Generated' },
    { number: '250%', label: 'Avg. Lead Growth' },
    { number: '4.9/5', label: 'Client Satisfaction' },
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-burgundy-950 via-burgundy-900 to-navy-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Why Choose <span className="text-red-500">Million Dollar Contractors</span>?
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              We're not just another marketing agency. We're specialists who understand the unique challenges of home service contractors and have a proven track record of turning small operations into million-dollar businesses.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-focus-3-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-white">Industry Expertise</h3>
                  <p className="text-gray-300">
                    We exclusively work with home service contractors, giving us deep insights into what works in your industry.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-robot-2-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-white">AI-Powered Solutions</h3>
                  <p className="text-gray-300">
                    Leverage cutting-edge AI technology to automate lead generation, customer service, and marketing campaigns.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-line-chart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-white">Proven Results</h3>
                  <p className="text-gray-300">
                    Our strategies have generated over $50M in revenue for contractors across the country.
                  </p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/10 transition-all hover:shadow-lg border border-white/10 cursor-pointer"
                >
                  <div className="text-4xl md:text-5xl font-bold text-red-500 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-gray-300 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10">
            <div className="aspect-[4/3] w-full h-full">
              <img
                src="https://public.readdy.ai/ai/img_res/879695b509a20a69160b67e4f8b9d193.jpg"
                alt="Professional contractor in van"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
